import { useEffect, useState } from 'react';

/**
 * True quando o ponteiro principal é grosso (dedo) — celular/tablet.
 *
 * Gestos de arrastar do framer-motion (`drag`) chamam `preventDefault()` no pointerdown,
 * o que mata a seleção de texto com o mouse (e, por tabela, o Cmd/Ctrl+C). Como puxar
 * pra fechar / swipe só fazem sentido no toque, os componentes desligam o `drag`
 * quando há mouse.
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches,
  );

  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse)');
    const update = () => setCoarse(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return coarse;
}
